import styled from 'styled-components'
import Mono from '../../../ui/Mono/Mono'

const pad = (n: number): string => String(n).padStart(2, '0')

const format = (value: unknown): string => {
  if (value == null || value === '') return ''
  const d = value instanceof Date ? value : new Date(String(value))
  if (Number.isNaN(d.getTime())) return String(value)
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${String(d.getFullYear()).slice(2)}`
}

export const DateCell = ({ value }: { value: unknown }) => <DateText>{format(value)}</DateText>

export default DateCell

const DateText = styled(Mono)`
  font-size: ${({ theme }) => theme.text.md};
  color: ${({ theme }) => theme.colors.ink3};
`
